var _excluded = ["kind", "minimizable", "size", "iconSize", "bodyHtml", "closeButtonText", "links", "children", "onOpen", "onClose", "isOpen", "scrollTo", "minimizedText", "className", "hideIcon"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import map from 'lodash/map';
import { Icon } from '../../atoms/Icon/Icon';
import { colors } from '../../utils/colors';

/**
 * Status: *finished*.
 * Category: Notifications
 */

var Alert = function Alert(_ref) {
  var _classnames;
  var _ref$kind = _ref.kind,
    kind = _ref$kind === void 0 ? 'positive' : _ref$kind,
    minimizable = _ref.minimizable,
    size = _ref.size,
    _ref$iconSize = _ref.iconSize,
    iconSize = _ref$iconSize === void 0 ? 'small' : _ref$iconSize,
    bodyHtml = _ref.bodyHtml,
    _ref$closeButtonText = _ref.closeButtonText,
    closeButtonText = _ref$closeButtonText === void 0 ? 'LUKK' : _ref$closeButtonText,
    _ref$links = _ref.links,
    links = _ref$links === void 0 ? [] : _ref$links,
    children = _ref.children,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    isOpen = _ref.isOpen,
    _ref$scrollTo = _ref.scrollTo,
    scrollTo = _ref$scrollTo === void 0 ? false : _ref$scrollTo,
    minimizedText = _ref.minimizedText,
    className = _ref.className,
    hideIcon = _ref.hideIcon,
    rest = _objectWithoutProperties(_ref, _excluded);
  var alertRef = useRef();
  var positiveAlert = kind === 'positive';
  useEffect(function () {
    if (scrollTo) {
      alertRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  });
  return /*#__PURE__*/React.createElement("div", _extends({
    ref: alertRef,
    className: classnames('alert', (_classnames = {}, _defineProperty(_classnames, className, className), _defineProperty(_classnames, "alert--".concat(kind), kind), _defineProperty(_classnames, "alert--".concat(size), size), _defineProperty(_classnames, "alert--minimizable", minimizable), _defineProperty(_classnames, "alert--minimized", minimizable && !isOpen), _classnames)),
    role: "alert"
  }, rest), /*#__PURE__*/React.createElement("div", {
    className: "alert__content"
  }, !hideIcon && /*#__PURE__*/React.createElement("div", {
    className: "alert__icon-container"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: positiveAlert ? 'check-mark-circle' : 'info',
    style: {
      color: positiveAlert ? colors.green700 : colors.black,
      width: iconSize === 'small' ? '1.5rem' : '2.5rem',
      height: iconSize === 'small' ? '1.5rem' : '2.5rem',
      marginRight: iconSize === 'small' ? '0.5rem' : '1rem'
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "alert__text-container"
  }, children ? children : bodyHtml, links.length > 0 ? /*#__PURE__*/React.createElement("ul", {
    className: "list list--links list--black"
  }, map(links, function (link, i) {
    return /*#__PURE__*/React.createElement("li", {
      key: i,
      className: "list__item"
    }, /*#__PURE__*/React.createElement("a", {
      className: "list__link",
      href: link.url,
      target: "_self"
    }, link.text));
  })) : null)), minimizable && /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    className: "alert__close"
  }, /*#__PURE__*/React.createElement("span", {
    className: "alert__close-text"
  }, closeButtonText), /*#__PURE__*/React.createElement(Icon, {
    icon: "close",
    className: "box__close-icon",
    style: {
      width: '1.7rem',
      height: '1.7rem',
      position: 'relative',
      top: '-0.3rem'
    }
  })), /*#__PURE__*/React.createElement("button", {
    onClick: onOpen,
    className: "alert__expand"
  }, minimizedText));
};
Alert.propTypes = {
  closeButtonText: PropTypes.string,
  kind: PropTypes.oneOf(['positive', 'negative', 'info', 'warning']),
  size: PropTypes.oneOf(['large', 'large-with-borders']),
  onOpen: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
  scrollTo: PropTypes.bool,
  minimizedText: PropTypes.string,
  links: PropTypes.arrayOf(PropTypes.shape({
    text: PropTypes.string,
    url: PropTypes.string
  })),
  hideIcon: PropTypes.bool,
  children: React.ReactNode
};
export default Alert;